import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable';
// import './styles.css';
import './style/style.css'
import React,{useEffect} from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.css';
import 'whatwg-fetch'
import {data} from "./content";
import Lottery from "./Lottery";
import {Helmet} from 'react-helmet'
import 'intersection-observer'
import {LANG} from './LangConfig'
import { Banner } from './Banner';
import { NewPrizes } from './NewPrizes';
import { Cars } from './Cars';
import { OtherPrizes } from './OtherPrizes';
import { HowTo } from './HowTo';
import { WhyTrade } from './WhyTrade';
import { Reasons5 } from './Reasons5';
import { SignUp } from './SignUp';
import { Footer } from './Footer';
import {sideMenu} from './Service';

// en, zh, id, vi, ar, es
const text = data[LANG];
// const text = data['ar'];

function App () {
    // useEffect(()=>{
    //     const btn=document.getElementsByClassName('open-btn')[0]
    //     const openRegForm=()=>sideMenu.openSelectedForm('register')
    //         btn.addEventListener('click',openRegForm )
    //     return ()=>{
    //         btn.removeEventListener('click', openRegForm)
    //     }

    // },[])
    return (
        <div>
            <Helmet>
                <title>{text.page_title}</title>
                <meta name="description" content={text.meta_description}/>
                <meta property="og:image" content={text.feature_img}/>
            </Helmet>

            <div className={`spin-and-win-2021 ${LANG}`}>
                <Banner content={{...text.banner, open_account:text.wheel.openAccount}} lang={LANG}/>
                <NewPrizes content={text.new_prizes} lang={LANG}/>
                <Cars content={text.cars} />
                <OtherPrizes content={text.other_prizes} lang={LANG}/>
                <HowTo content={text.how_to} lang={LANG} />
                <Lottery text={text.wheel} lang={LANG}/>
                <WhyTrade content={text.why_trade} />
                <Reasons5 content={text.reasons5} lang={LANG} />
                <SignUp content={text.sign_up} lang={LANG}/>
                <Footer content={text.footer} lang={LANG} />

            </div>
        </div>
    )
};


ReactDOM.render(<App/>, document.getElementById('root'));
